import styled from "styled-components";

export const StyledError = styled.span `
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 15px;

    color: var(--color-salmon);
`